import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

import { COLORS } from '@theme/colors';
import { LETTER_SPACING, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled(motion.div)``;

export const InnerContainer = styled.div<{ containerHeight: number }>`
  position: relative;
  margin: 0 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ containerHeight }) => containerHeight}px;
  overflow: auto;
  border-top: 1px solid ${COLORS.BLACK};
  padding-top: 1px;
`;

export const CloseButton = styled.button`
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 6px;
    height: 12px;
    width: 1px;
    background-color: ${COLORS.BLACK};
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0 ${OFFSET.S};
`;

export const Title = styled.div`
  ${typography({ spacing: LETTER_SPACING.S })};
  text-transform: uppercase;
  margin: 0 auto;
`;

export const StepNavigation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 25px;
`;

const buttonStyles = css<{ hide: boolean; disabled?: boolean }>`
  visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
  pointer-events: ${({ hide }) => (hide ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  padding: 0;
`;

export const NextStep = styled.button`
  ${buttonStyles};
`;

export const PrevStep = styled.button`
  ${buttonStyles};
`;

export const PrevArrow = styled.i`
  margin-right: 9px;
`;

export const NextArrow = styled.i`
  margin-left: 9px;
`;
